export default {
    // 配置项
    BASE_API: "http://api.shbhgy.com",
    //BASE_API: "http://101.36.227.6:8082",
    //BASE_API: "http://gygwapi.ran-wei.net",
    //BASE_API: "https://localhost:44334/",
}